module.exports = __webpack_public_path__ + "static/img/tcl.a84e8ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tcl.png
// module id = 8crJ
// module chunks = 0